//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'lodash/debounce';
import CloseIcon from '~/assets/svg/ic-close.svg?inline';

export default {
  components: {
    CloseIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fullHeight: false,
    };
  },
  created() {
    this.resizeHandler();
    window.addEventListener('resize', debounce(this.resizeHandler, 10));
  },
  destroyed() {
    window.removeEventListener('resize', debounce(this.resizeHandler, 10));
  },
  methods: {
    closeDialog() {
      this.$emit('change', false);
      this.$emit('close');
    },
    resizeHandler() {
      this.fullHeight = window.innerHeight < 601;
    },
  },
};
